function fallbackCopyTextToClipboard(text: string) {
  var textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  // textArea.focus(); // https://stackoverflow.com/questions/59906699/clicking-button-jumps-to-bottom-of-screen-for-no-reason
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    console.log('Fallback: Copying text command was ' + msg)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
}

export default async function copyTextToClipboard(text: string) {
  return new Promise<void>((resolve, reject) => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text)
      return
    }
    navigator.clipboard.writeText(text).then(
      function () {
        console.log('Async: Copying to clipboard was successful!')
        resolve()
      },
      function (err) {
        console.error('Async: Could not copy text: ', err)
        reject()
      },
    )
  })
}
